const PubSub = (() => {
  const topics = {};
  let uid = 0;

  const subscribe = (topic, func) => {
    if (!topics[topic]) {
      topics[topic] = {
        subscribers: [],
      };
    }
    uid += 1;
    const token = uid.toString();
    topics[topic].subscribers.push({
      token,
      func,
    });
    return unsubscribe.bind(this, topic, token);
  };

  const unsubscribe = (topic, token) => {
    if (!topics[topic]) return false;

    const { subscribers = [] } = topics[topic];
    subscribers.some((subscriber, index) => {
      if (subscriber.token === token) {
        subscribers.splice(index, 1);
        return true;
      }
      return false;
    });
    return true;
  };

  const publish = (topic, args) => {
    if (!topics[topic]) {
      return false;
    }

    if (topics[topic]) {
      const { subscribers = [] } = topics[topic];
      subscribers.some(item => {
        try {
          const fn = item.func;
          fn(topic, args);
          return true;
        } catch (e) {
          console.error(e);
          return false;
        }
      });
    }
    return true;
  };

  return {
    subscribe,
    publish,
  };
})();

export default PubSub;
